// can be removed after fixed in sd-tab
sd-tab::part(base) {
  width: auto;
  min-width: 5rem;
}
